<template>
    <div class="text-center">
        <agile class="flex-grow-1 h-100"
               dir="ltr"
               :nav-buttons="false"
               :initial-slide="0">

            <div class="position-relative h-100">
                <img class="d-block h-100 mx-auto" :src="require('../assets/img/tutorial/1.gif')">
            </div>

            <div class="position-relative h-100">
                <img class="d-block h-100 mx-auto" :src="require('../assets/img/tutorial/2.gif')">
            </div>

            <div class="position-relative h-100">
                <img class="d-block h-100 mx-auto" :src="require('../assets/img/tutorial/3.gif')">
            </div>

            <div class="position-relative h-100">
                <img class="d-block h-100 mx-auto" :src="require('../assets/img/tutorial/4.gif')">
            </div>

            <div class="position-relative h-100">
                <img class="d-block h-100 mx-auto" :src="require('../assets/img/tutorial/5.gif')">
            </div>

            <template slot="prevButton"><i class="fa fa-chevron-left"></i></template>
            <template slot="nextButton"><i class="fa fa-chevron-right"></i></template>
        </agile>
    </div>
</template>

<script>
    import {VueAgile} from 'vue-agile';

    export default {
        name: "Guide",
        components: {
            agile: VueAgile
        },
    }
</script>

<style scoped>
</style>
